import { useEffect } from 'react';

import { SERVICE_GROUP_ID } from '@/constants';
import i18n from '@/settings/i18n';
import { generatePath, useNavigate } from 'react-router';
import { pages } from '@/settings/pages';
import { useFlashMessenger } from '@/hooks/useFlashMessenger';
import { isNewAndEditAndCancelOfEmba2Ended } from '@/utils/date';

type Args = {
  serviceGroupId: number | null;
};

export const useSubscriptionAccessGuard = ({
  serviceGroupId,
}: Args): { shouldRedirect: boolean } => {
  const navigate = useNavigate();
  const { flashError } = useFlashMessenger();

  const shouldRedirect =
    (!!serviceGroupId && serviceGroupId !== SERVICE_GROUP_ID.emba) ||
    isNewAndEditAndCancelOfEmba2Ended();

  useEffect(() => {
    if (!serviceGroupId) return;
    if (shouldRedirect) {
      flashError(i18n.t('ui.error.unexpected'));
      navigate(generatePath(pages.service.detail, { id: String(serviceGroupId) }));
    }
  }, [serviceGroupId, flashError, navigate, shouldRedirect]);

  return { shouldRedirect };
};
